module.exports = __webpack_public_path__ + "static/img/pvc film_page bottom_desktop.71da9352.jpg";